import { API_BASE_URL, HEADERS_WITH_TOKEN, HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE } from "services/api/BaseUrl"

export const getAll = async() => {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))

  const res = await fetch(
    `${API_BASE_URL}/branch-offices?cmp=${usr.company._id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}
  

export const save = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/branch-offices`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE(localStorage.getItem('mqadtk')),
      body: params
    }
  )
  return await res.json()
}

export const edit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/branch-offices/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE(localStorage.getItem('mqadtk')),
      body: params
    }
  )
  return await res.json()
}

export const remove = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/branch-offices/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}

export const updateActive = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/branch-offices/update-active/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}